import { RoutePath } from "#utils/route";
import { FlowDetailRoute } from "#routes/organization/flows/[flowId]/detail";

export const FlowCreateEstimationMethodRoute = FlowDetailRoute.concat(
  new RoutePath({
    path: "/create-estimation-method",
    title: "Add Estimation Method",
  })
);
